import { formatUsd } from '@/Client/Presenters';
import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../Styles';

const SCAN_EDITOR_PAGE_TITLE_BAR_STYLE = css`
  label: SCAN_EDITOR_PAGE_TITLE_BAR_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing}px;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  background: ${COLORS2.alwaysDark.background.dark};
  border-bottom: 1px solid var(--border);
  padding-left: ${LAYOUT2.spacing2}px;
`;

const SCAN_EDITOR_PAGE_TITLE_BAR_NAME_STYLE = css`
  label: SCAN_EDITOR_PAGE_TITLE_BAR_NAME_STYLE;
  ${TYPOGRAPHY2.smallBold}
  color: ${COLORS2.alwaysDark.text.white};
  flex-grow: 1;
`;

const SCAN_EDITOR_PAGE_TITLE_BAR_DATA_LABEL_STYLE = css`
  label: SCAN_EDITOR_PAGE_TITLE_BAR_DATA_LABEL_STYLE;
  ${TYPOGRAPHY2.small}
  color: ${COLORS2.alwaysDark.text.white};
  padding-bottom: 1px;
`;

const SCAN_EDITOR_PAGE_TITLE_BAR_DATA_UNIT_STYLE = css`
  label: SCAN_EDITOR_PAGE_TITLE_BAR_DATA_UNIT_STYLE;
  ${TYPOGRAPHY2.small}
  color: ${COLORS2.alwaysDark.text.green};
`;

const SCAN_EDITOR_PAGE_TITLE_BAR_PRICE_VALUE_STYLE = css`
  label: SCAN_EDITOR_PAGE_TITLE_BAR_PRICE_VALUE_STYLE;
  ${TYPOGRAPHY2.large}
  color: ${COLORS2.alwaysDark.text.green};
`;

const SCAN_EDITOR_PAGE_TITLE_BAR_DATA_CONTAINER_STYLE = css`
  label: SCAN_EDITOR_PAGE_TITLE_BAR_DATA_CONTAINER_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing1}px;
  align-items: flex-end;
`;

const TITLE_BAR_BUTTONS_STYLE = css`
  label: TITLE_BAR_BUTTONS_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing1}px;
  align-items: center;
`;

export const SlimScanEditorPageTitleBar = ({ title, area, cost, showArea = false, buttons }: {
  title: string;
  area?: number;
  cost?: number;
  showArea?: boolean;
  buttons?: ReactNode[];
}) => (
  <div css={SCAN_EDITOR_PAGE_TITLE_BAR_STYLE}>
    <div css={SCAN_EDITOR_PAGE_TITLE_BAR_NAME_STYLE}>{title}</div>
    {showArea && area != null && (
      <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_CONTAINER_STYLE}>
        <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_LABEL_STYLE}>Area:</div>
        <div css={SCAN_EDITOR_PAGE_TITLE_BAR_PRICE_VALUE_STYLE}>{Math.round(area)}</div>
        <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_UNIT_STYLE}>sqft</div>
      </div>
    )}
    {showArea && area === undefined && (
      <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_CONTAINER_STYLE}>
        <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_LABEL_STYLE}>Area:</div>
        <div css={SCAN_EDITOR_PAGE_TITLE_BAR_PRICE_VALUE_STYLE}>TBD</div>
      </div>
    )}
    <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_CONTAINER_STYLE}>
      <div css={SCAN_EDITOR_PAGE_TITLE_BAR_DATA_LABEL_STYLE}>Cost:</div>
      <div css={SCAN_EDITOR_PAGE_TITLE_BAR_PRICE_VALUE_STYLE}>{formatUsd(cost)}</div>
    </div>
    {buttons && (
      <div css={TITLE_BAR_BUTTONS_STYLE}>
        {buttons}
      </div>
    )}
  </div>
);
